import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-filter",
  "use": "icon-filter-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-filter\"><path d=\"M804.3 176.8c-6.2-13.4-19.7-22-34.4-22H203.1c-14.7 0-28.2 8.6-34.4 22-6.2 13.4-4.1 29.3 5.5 40.6L369.6 447v284.4c0 12.2 5.9 23.8 15.8 31.1L542 876.6c6.8 4.9 14.6 7.4 22.6 7.4 6 0 12-1.4 17.5-4.2 13-6.6 21-19.8 21-34.3V447l195.5-229.7c9.7-11.3 11.9-27.2 5.7-40.5zM539.2 423.4v371.8l-105.4-76.8v-295L259.7 218.9h453.6L539.2 423.4z\" /><path d=\"M666.4 471.6H828v64.1H666.4zM666.4 592.5H828v64.1H666.4zM666.4 713.3H828v64.1H666.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol